/**
 * AutoLux Scroll Reveal + light desktop parallax
 * Progressive enhancement only. Headings visible without JS.
 * - IntersectionObserver drives reveals (no per-frame work for reveals).
 * - ONE rAF-throttled scroll handler powers a SUBTLE desktop-only parallax,
 *   disabled on mobile (<960px) and when prefers-reduced-motion is set.
 */
(function () {
  'use strict';

  // Pause everything in the Shopify theme editor (so authoring is stable)
  if (window.Shopify && Shopify.designMode) return;

  // Respect reduced motion — bail entirely
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('al-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observe(el) {
    el.setAttribute('data-rv-ready', '');
    io.observe(el);
  }

  function init() {
    // 1) Auto "slide-in-from-left" for text elements across all sections.
    //    Only upgrades elements that already opt into reveal via .al-rv.
    var LEFT = '[class*="__heading"],[class*="__eyebrow"],[class*="__title"],[class*="__body"],[class*="__sub"],.al-h1,.al-h2,.al-h3';
    Array.prototype.forEach.call(document.querySelectorAll(LEFT), function (el) {
      if (el.classList.contains('al-rv') && !el.classList.contains('al-rv--left')) {
        el.classList.add('al-rv--left');
      }
    });

    // 2) Auto-stagger known grid containers (children fade/slide in sequence).
    //    Tables are excluded on purpose (transform on <tr> is unreliable).
    ['.al-trust__grid', '.al-material__features', '.al-process__steps',
     '.al-ugc__grid', '.al-faq__list', '.al-stats__grid'
    ].forEach(function (sel) {
      var g = document.querySelector(sel);
      if (g && !g.hasAttribute('data-rv-stagger')) g.setAttribute('data-rv-stagger', '');
    });

    // 3) Base reveals
    Array.prototype.forEach.call(document.querySelectorAll('.al-rv'), observe);

    // 4) Staggered children
    Array.prototype.forEach.call(document.querySelectorAll('[data-rv-stagger]'), function (group) {
      var delay = parseFloat(group.dataset.rvDelay || 0.09);
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.classList.contains('al-rv')) child.classList.add('al-rv');
        child.setAttribute('data-rv-ready', '');
        child.style.transitionDelay = (i * delay) + 's';
        io.observe(child);
      });
    });

    // 5) Founder "atelier dossier" callouts + corner-bracket draw (desktop-only
    //    effect via CSS @media; harmless on mobile where overlay is hidden).
    Array.prototype.forEach.call(
      document.querySelectorAll('.al-founder__anno, .al-founder__anno-line, .al-founder__bracket'),
      function (el, i) {
        el.setAttribute('data-rv-ready', '');
        el.style.transitionDelay = (0.15 + i * 0.12) + 's';
        io.observe(el);
      }
    );

    // 6) Subtle desktop-only parallax on the cinematic video media.
    setupParallax();
  }

  function setupParallax() {
    if (!(window.matchMedia && window.matchMedia('(min-width: 960px)').matches)) return;
    var layers = Array.prototype.slice.call(document.querySelectorAll('.al-cine__media'));
    if (!layers.length) return;

    var ticking = false;
    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      layers.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var center = r.top + r.height / 2;
        var off = (center - vh / 2) / vh;            // -0.5 .. 0.5
        var shift = Math.max(-18, Math.min(18, off * -28));
        el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestAnimationFrame(function () { requestAnimationFrame(init); });
  }
})();
